import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const PersonIconSvg = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 11.833C13.8478 11.8331 14.9832 12.2891 15.8363 13.1059C16.6894 13.9228 17.1942 15.0374 17.2454 16.2174L17.25 16.4163V17.333C17.2501 17.7955 17.0755 18.241 16.761 18.5802C16.4465 18.9193 16.0154 19.1271 15.5542 19.1618L15.4167 19.1663H2.58333C2.12081 19.1665 1.67531 18.9918 1.33616 18.6773C0.997015 18.3628 0.789273 17.9317 0.754583 17.4705L0.75 17.333V16.4163C0.750068 15.2352 1.20608 14.0998 2.02294 13.2467C2.8398 12.3936 3.95444 11.8889 5.13442 11.8376L5.33333 11.833H12.6667ZM9 0.833008C10.2156 0.833008 11.3814 1.31589 12.2409 2.17544C13.1004 3.03498 13.5833 4.20077 13.5833 5.41634C13.5833 6.63192 13.1004 7.79771 12.2409 8.65725C11.3814 9.51679 10.2156 9.99967 9 9.99967C7.78442 9.99967 6.61864 9.51679 5.75909 8.65725C4.89955 7.79771 4.41667 6.63192 4.41667 5.41634C4.41667 4.20077 4.89955 3.03498 5.75909 2.17544C6.61864 1.31589 7.78442 0.833008 9 0.833008Z"
      fill="currentColor"
    />
  </svg>
);

export const PersonIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={() => <PersonIconSvg />} {...props} />
);

export default PersonIcon;

PersonIcon.displayName = "PersonIcon";
